import LazyImage from './lazy_image';

export default LazyImage;
